// SurfacePanels — mounts the standalone diagnostic panels that are NOT engine
// windows: the passive target-info HUD readout + the surface-bound Arena
// control panel.
//
// Phase 3 replaced the old DiagnosticsOverlay (which mounted every diagnostic
// panel behind DiagnosticsContext flags). The observational/toggleable panels
// were folded into the unified window engine (WindowHost). What's left here are
// the panels that stay STANDALONE:
//   - TargetInfoPanel — a passive on-screen target frame, DevConfig-gated, with
//     no toggle/close (auto-shows on target). Not a window.
//   - ArenaPanel — fixed-position PRIMARY CONTROL surface for /arena,
//     auto-shown on the mode's route. Not a draggable window (yet — candidate
//     for the same treatment as the Grounds when asked).
//
// 2026-06-12: AbilityGroundsPanel moved INTO the window engine (registry id
// 'abilityGrounds', diagnostic kind — draggable/closable, auto-opened via
// urlSeed 'grounds' which ABILITY_GROUNDS_CONFIG injects).
//
// Surface detection is the same predicate DiagnosticsContext used (map id /
// pathname), now local to this mount point — no shared context. jsdom guards
// carried forward.

import React from 'react';
import { DevConfig } from '../../../config/environment/devConfig';
import { TargetInfoPanel } from './TargetInfoPanel';
import { ArenaPanel } from './ArenaPanel';
import { bootPathname, bootSearchParams } from '../../../config/boot/bootUrl';

function detectSurface(): { arena: boolean } {
  if (typeof window === 'undefined') return { arena: false };
  try {
    const params = bootSearchParams();
    const arena =
      params.get('map') === 'arena-multi-level' ||
      bootPathname() === '/arena';
    return { arena };
  } catch {
    return { arena: false };
  }
}

export const SurfacePanels: React.FC = () => {
  // Surface is stable for the mount session (URL doesn't mutate without a
  // navigation, which unmounts), so reading once is safe.
  const { arena } = detectSurface();

  return (
    <>
      {DevConfig.systems.targetInfo && <TargetInfoPanel />}
      {arena && <ArenaPanel />}
    </>
  );
};
